module.exports = __webpack_public_path__ + "img/33_33.fce0e643.png";